import { render, staticRenderFns } from "./EducationPieChart.vue?vue&type=template&id=37c55ddc"
import script from "./EducationPieChart.vue?vue&type=script&lang=js"
export * from "./EducationPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports